module.exports = __webpack_public_path__ + "fonts/Rokkitt-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Rokkitt/Rokkitt-Regular.ttf
// module id = 3481
// module chunks = 0